import angular from 'angular';
import pageComponent from './page.component';

import pageConfig from './page.config';

let pageModule = angular.module('app.page',[])
  .component('page', pageComponent)
  .config(pageConfig);

export default pageModule;



// WEBPACK FOOTER //
// ./www/components/page/page.js